module.exports = __webpack_public_path__ + "static/media/googleBlack.c5c028b5.svg";